/**
 * @module
 *
 * @import {Local} from "@acng/frontend-relativity"
 */

import {Context, LocalActor, localValue, Watch} from '@acng/frontend-relativity';
import {State} from '@acng/frontend-voyager';

/**
 * @type {Local<State>}
 */
export const ctxState = Context();

/**
 * Get the current local {@link State | state}.
 *
 * @param {Element} element
 */
export const getState = (element) => localValue(element, ctxState);

/**
 * Create a local {@link State | state} provider.
 */
export const StateProvider = () => LocalActor(ctxState);

/**
 * Create a local {@link State | state} observer.
 *
 * @param {string} signature
 */
export const StateObserver = (signature) => Watch(signature, ctxState);
